/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const SalesProspectingLeadGenerationQuote = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      company="Retarus"
      title={t('Retarus: Optimizing Prospecting in Spain')}
      summary={t(
        'Retarus identifies new B2B customers matching its Ideal Customer Profile in Spain far more efficiently than manual list-building allowed.',
      )}
      href="/retarus-optimizing-prospecting-in-spain-with-global-database"
    />
  );
};
